import React, {useEffect, useRef, useState} from 'react'
import {Image, Rect, Transformer} from "react-konva";
import useImage from "use-image";
import {BLOCK_SNAP_SIZE} from "../../../design/constants/design.constant";

const ImageRectangle = ({
                            imageDetail,
                            onChange,
                            onClick,
                            setSelectedImage,
                            isSelected,
                            childItemsRefList = [],
                        }) => {
    const [image] = useImage(imageDetail.url, 'anonymous');
    const shapeRef = React.useRef();
    // const [isSelected, setIsSelected] = useState(false);
    // const transformerRef = useRef(null);

    const handleDragEnd = (event) => {
        const node = shapeRef.current || undefined;

        const currentNodeRef = event.target;
        currentNodeRef.position({
            x: Math.round(currentNodeRef.x() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE,
            y: Math.round(currentNodeRef.y() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE
        });

        onChange({
            ...imageDetail?.props,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            totalWidth: node.width(),
            totalHeight: node.height()
        });
    }

    /*useEffect(() => {
        console.log(imageDetail.id, ' - isSelected', isSelected);

        if (isSelected) {
            if (transformerRef) {
                transformerRef?.current?.nodes([shapeRef.current]);
            }
        } else {
            if (transformerRef) {
                transformerRef?.current?.nodes([]);
            }
        }
    }, [isSelected]);*/

    const handleSelect = () => {
        // setIsSelected(true);
        setSelectedImage(imageDetail);
        // transformerRef.current.nodes([shapeRef.current]);
    };

    const handleDeselect = () => {
        // setIsSelected(false);
        // transformerRef.current.nodes([]);
    };

    return (
        <>
            {image &&
                <>
                    {/*<Rect
                        name={'image-rectangle'}
                        // ref={shapeRef}
                        ref={(node) => {
                            // @ts-ignore
                            shapeRef.current = node;
                            childItemsRefList[imageDetail?.id] = node;
                        }}
                        fillPatternImage={image}
                        fillPatternRepeat={'no-repeat'}
                        {...imageDetail?.props}
                        draggable
                        onClick={onClick}
                        onSelect={() => {
                            setSelectedImage(imageDetail);
                        }}
                        onDragMove={(e) => {
                            handleDragEnd(e);
                        }}
                        onDragEnd={(e) => {
                            handleDragEnd(e);
                        }}

                    />*/}

                    <Image
                        ref={(node) => {
                            // @ts-ignore
                            shapeRef.current = node;
                            childItemsRefList[imageDetail?.id] = node;
                        }}
                        {...imageDetail?.props}
                        name={'image'}
                        image={image}
                        draggable
                        onClick={onClick}
                        onSelect={() => {
                            setSelectedImage(imageDetail);
                        }}
                        onDragMove={(e) => {
                            handleDragEnd(e);
                        }}
                        onDragEnd={(e) => {
                            handleDragEnd(e);
                        }}

                    />

                    {/*{isSelected && (
                        <Transformer
                            ref={transformerRef}
                            boundBoxFunc={(oldBox, newBox) => {
                                // Restrict the transformer to stay within the stage boundaries
                                if (newBox.width < 5 || newBox.height < 5) {
                                    return oldBox;
                                }

                                return newBox;
                            }}
                        />
                    )}*/}
                </>
            }
        </>
    )
}

export default ImageRectangle
